import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';

class ThumbnailSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('[data-js="thumbnail-slider-main"]');
    this.dom.thumbnail = this.dom.el.querySelector('[data-js="thumbnail-slider-thumb"]');

    this.slider = null;
    this.thumbnail = null;
    this.option = {
      type      : 'fade',
      rewind    : true,
      pagination: false,
      arrows    : false,
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    // this.slider.mount();

    this.thumbnail = new Splide(this.dom.thumbnail, {
      fixedWidth  : 40,
      fixedHeight : 40,
      gap         : 10,
      rewind      : true,
      pagination  : false,
      cover       : true,
      isNavigation: true,
      mediaQuery: 'min',
      breakpoints : {
        768: {
          fixedWidth : 60,
          fixedHeight: 60,
        },
      },
    } );

    this.slider.sync( this.thumbnail );
    this.slider.mount();
    this.thumbnail.mount();
  }
}

export default ThumbnailSlides